/* Botaverra - section "Collection en bandes".

   ======================================================================
   MODIFIE LE 2026-09-04 - LE MODE TELEPHONE S'APPLIQUE PARTOUT.

   Demande explicite : "la version PC de la collection, je veux la meme qu'en
   version mobile". Deux changements, tous deux reversibles en une ligne.

   1. LES CARTES ne sont plus reservees au telephone. La garde
      `MOBILE.matches` a ete retiree de appliquer(), battement() et du geste
      tactile : une seule tour s'affiche a la fois, quelle que soit la largeur.
      POUR REVENIR EN ARRIERE : remettre `if (MOBILE.matches)` dans
      appliquer(), et `|| !MOBILE.matches` dans battement().

   2. LE DIAPORAMA DE PHOTOS EST ETEINT (DIAPO_ACTIF ci-dessous). Il n'existe
      pas sur telephone, et la feuille botaverra-bandes-partout.css masque
      desormais toutes les photos sauf la premiere : le laisser tourner
      chargerait des images invisibles. POUR LE RALLUMER : passer DIAPO_ACTIF
      a true.

   La mise en page correspondante vit dans assets/botaverra-bandes-partout.css.
   Les deux vont ensemble : retirer l'une sans l'autre laisse la section a
   moitie basculee.
   ======================================================================

   MOUVEMENT REDUIT : rien ne demarre.

   ATTENTION AUX NOMS D'ATTRIBUTS : `data-bvcb-diapo` porte le DELAI, et le
   drapeau d'initialisation vit dans `data-bvcb-diapo-pret`. Les confondre
   ecraserait le delai par le drapeau des le premier passage. */
(function () {
  var REDUIT = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MOBILE = window.matchMedia('(max-width: 749px)');

  /* Diaporama de photos : eteint le 2026-09-04, voir l'entete. */
  var DIAPO_ACTIF = false;

  /* Au moins un tiers de la section dans la fenetre. Lecture de position et
     PAS d'IntersectionObserver : mesure du 2026-08-22, l'observateur ne se
     declenche pas dans tous les contextes et l'animation restait alors figee.
     C'est aussi la seule methode sure ici, la page defilant dans
     `.page-wrapper` et non dans la fenetre. */
  function aLEcran(el, part) {
    var r = el.getBoundingClientRect();
    var haut = Math.max(r.top, 0);
    var bas = Math.min(r.bottom, window.innerHeight);
    return r.height > 0 && (bas - haut) / r.height > (part || 0.33);
  }

  function ecouterLargeur(fn) {
    if (MOBILE.addEventListener) {
      MOBILE.addEventListener('change', fn);
    } else if (MOBILE.addListener) {
      MOBILE.addListener(fn);
    }
  }

  /* ======================================================================
     1. UN SEUL MODELE A LA FOIS - a toutes les largeurs depuis le 2026-09-04
     ====================================================================== */
  function initCartes(section) {
    if (section.dataset.bvcbPret === 'oui') return;
    section.dataset.bvcbPret = 'oui';

    var piste = section.querySelector('.bvcb__bandes');
    if (!piste) return;

    var cartes = [].slice.call(piste.querySelectorAll('.bvcb__bande'));
    if (cartes.length < 2) return;

    var delai = parseInt(section.getAttribute('data-bvcb-auto'), 10) || 0;
    var index = 0;
    var minuteur = null;
    var rendu = false; /* le visiteur a pris la main : on ne la reprend plus */

    /* Les libelles des points viennent du surtitre et du nom du bloc : ils
       suivent donc ce que l'utilisateur saisit dans l'editeur. */
    var points = document.createElement('div');
    points.className = 'bvcb__points';

    var boutons = cartes.map(function (carte, i) {
      var b = document.createElement('button');
      var sur = carte.querySelector('.bvcb__sur');
      var nom = carte.querySelector('.bvcb__nom');
      var mots = [];
      if (sur && sur.textContent.trim()) mots.push(sur.textContent.trim());
      if (nom && nom.textContent.trim()) mots.push(nom.textContent.trim());

      b.type = 'button';
      b.className = 'bvcb__point';
      b.setAttribute('aria-label', mots.length ? mots.join(' — ') : 'Modèle ' + (i + 1));
      b.addEventListener('click', function () {
        rendreLaMain();
        montrer(i);
      });
      points.appendChild(b);
      return b;
    });

    piste.parentNode.insertBefore(points, piste.nextSibling);

    function montrer(i) {
      index = (i + cartes.length) % cartes.length;
      cartes.forEach(function (c, n) {
        if (n === index) {
          c.setAttribute('data-bvcb-actif', '');
        } else {
          c.removeAttribute('data-bvcb-actif');
        }
      });
      boutons.forEach(function (b, n) {
        b.setAttribute('aria-current', n === index ? 'true' : 'false');
      });
    }

    function battement() {
      if (rendu || !aLEcran(section)) return;
      montrer(index + 1);
    }

    function demarrer() {
      arreter();
      if (!rendu && !REDUIT && delai) minuteur = window.setInterval(battement, delai);
    }

    function arreter() {
      if (minuteur) {
        window.clearInterval(minuteur);
        minuteur = null;
      }
    }

    function rendreLaMain() {
      rendu = true;
      arreter();
    }

    /* Seul un geste franchement horizontal compte. Le facteur 1,5 evite qu'un
       balayage vertical un peu de biais - le cas courant, le pouce decrit un
       arc - ne soit pris pour un changement de carte. */
    var x0 = 0;
    var y0 = 0;

    piste.addEventListener('touchstart', function (e) {
      var t = e.changedTouches[0];
      x0 = t.clientX;
      y0 = t.clientY;
    }, { passive: true });

    piste.addEventListener('touchend', function (e) {
      var t = e.changedTouches[0];
      var dx = t.clientX - x0;
      var dy = t.clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        rendreLaMain();
        montrer(index + (dx < 0 ? 1 : -1));
      }
    }, { passive: true });

    /* Plus de test de largeur : le mode carte vaut desormais partout. */
    section.classList.add('bvcb--fondu');
    montrer(index);
    demarrer();
  }

  /* ======================================================================
     2. DIAPORAMA DES PHOTOS - ETEINT depuis le 2026-09-04 (DIAPO_ACTIF).

     Conserve entier : c'est le resultat de deux allers-retours avec
     l'utilisateur le 2026-08-23, et le rallumer ne demande qu'un booleen.

     LE FOND DE LA VIGNETTE PORTE LA PHOTO QU'ON QUITTE. Le probleme n'a jamais
     ete le fondu, mais ce qu'il y avait DERRIERE. Deux photos qui se croisent
     valent 0,5 chacune a mi-parcours ; la couverture composite tombe a
     1 - 0,5 x 0,5 = 0,75 et le fond de la vignette (#f0fdf4) transparait a
     25 %. D'ou la "coupure avec le fond vert" signalee.

     Solution : avant chaque changement, la photo sortante est recopiee en
     `background-image` de la vignette. L'entrante monte de 0 a 1 par-dessus,
     et le composite vaut exactement `t x nouvelle + (1 - t) x ancienne`.

     LES PHOTOS SUIVANTES N'ONT PAS DE `src` DANS LE HTML : posees normalement
     puis masquees en `display: none`, elles etaient TOUTES TELECHARGEES quand
     meme. Le gabarit ecrit donc l'adresse dans `data-bvcb-src`, et c'est ce
     script qui la promeut en `src`.
     ====================================================================== */
  function charger(imgs) {
    imgs.forEach(function (i) {
      if (!i.dataset.bvcbSrc || i.getAttribute('src')) return;
      if (i.dataset.bvcbSrcset) i.setAttribute('srcset', i.dataset.bvcbSrcset);
      i.setAttribute('src', i.dataset.bvcbSrc);
    });
  }

  function prete(img) {
    return img.complete && img.naturalWidth > 0;
  }

  function initDiapo(section) {
    if (!DIAPO_ACTIF) return;
    if (REDUIT) return;
    if (section.dataset.bvcbDiapoPret === 'oui') return;

    var delai = parseInt(section.getAttribute('data-bvcb-diapo'), 10);
    if (!delai) return;
    section.dataset.bvcbDiapoPret = 'oui';

    var scenes = [];
    var toutes = [];
    section.querySelectorAll('.bvcb__media').forEach(function (media) {
      var imgs = [].slice.call(media.querySelectorAll('.bvcb__img'));
      if (imgs.length < 2) return;
      media.classList.add('bvcb__media--js');
      media.style.backgroundSize = 'cover';
      media.style.backgroundPosition = 'center';
      imgs[0].classList.add('bvcb__img--vue');
      imgs[0].style.zIndex = '1';
      scenes.push({ media: media, imgs: imgs, i: 0, z: 1 });
      toutes = toutes.concat(imgs);
    });
    if (!scenes.length) return;

    function surLargeur() {
      if (!MOBILE.matches) charger(toutes);
    }

    ecouterLargeur(surLargeur);
    surLargeur();

    function prochaine(sc) {
      for (var k = 1; k < sc.imgs.length; k++) {
        var n = (sc.i + k) % sc.imgs.length;
        if (prete(sc.imgs[n])) return n;
      }
      return -1;
    }

    function avancer(sc) {
      if (MOBILE.matches || !aLEcran(section, 0.2)) return;

      var suivant = prochaine(sc);
      if (suivant < 0) return;

      var sortante = sc.imgs[sc.i];
      var url = sortante.currentSrc || sortante.getAttribute('src');
      if (!url) return;
      sc.media.style.backgroundImage = 'url(\"' + url + '\")';

      sc.i = suivant;
      var entrante = sc.imgs[sc.i];

      sc.z += 1;
      entrante.style.zIndex = String(sc.z);
      entrante.classList.add('bvcb__img--vue');
      sortante.classList.remove('bvcb__img--vue');

      if (sc.z > sc.imgs.length * 3) {
        sc.imgs.forEach(function (im) { im.style.zIndex = '0'; });
        entrante.style.zIndex = '1';
        sc.z = 1;
      }
    }

    scenes.forEach(function (sc, n) {
      var decalage = Math.round((delai / scenes.length) * n);
      window.setTimeout(function () {
        window.setInterval(function () { avancer(sc); }, delai);
      }, decalage);
    });
  }

  function tout() {
    document.querySelectorAll('.bvcb--glisse').forEach(initCartes);
    document.querySelectorAll('[data-bvcb-diapo]').forEach(initDiapo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tout);
  } else {
    tout();
  }

  /* Dans l'editeur, une section rechargee perd son initialisation - et ses
     points, recrees avec le nouveau balisage. On remet a zero les DRAPEAUX,
     jamais l'attribut qui porte le delai. */
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.bvcb').forEach(function (s) {
      s.dataset.bvcbPret = '';
      s.dataset.bvcbDiapoPret = '';
      var p = s.querySelector('.bvcb__points');
      if (p) p.remove();
    });
    tout();
  });
})();
